import { toast } from "sonner";
import { useLazyGetExportDownloadQuery } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export function useExportDownload() {
  const [fetchDownload, { isFetching }] = useLazyGetExportDownloadQuery();

  async function downloadExport(exportId: string) {
    try {
      const download = await fetchDownload(exportId).unwrap();
      const anchor = document.createElement("a");
      anchor.href = download.url;
      anchor.download = download.fileName;
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
    } catch (error: unknown) {
      toast.error(apiErrorMessage(error, "The export could not be downloaded"));
    }
  }

  return { downloadExport, downloading: isFetching };
}
